// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 576 512\"><!--! Font Awesome Pro 6.0.0-beta1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) --><path d=\"M32 384C23.16 384 16 391.2 16 400v96c0 8.844 7.156 16 15.1 16S48 504.8 48 496v-96C48 391.2 40.84 384 32 384z\"/></svg>";
// Exports
module.exports = code;